import { render, staticRenderFns } from "./ClaimLifeCycle.vue?vue&type=template&id=6c6c23ce&"
import script from "./ClaimLifeCycle.vue?vue&type=script&lang=js&"
export * from "./ClaimLifeCycle.vue?vue&type=script&lang=js&"
import style0 from "./ClaimLifeCycle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports